import { render } from "./AdminGameDetail.vue?vue&type=template&id=6ae261a0&scoped=true&lang=pug"
import script from "./AdminGameDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminGameDetail.vue?vue&type=script&setup=true&lang=js"

import "./AdminGameDetail.vue?vue&type=style&index=0&id=6ae261a0&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae261a0"]])

export default __exports__